import { Injectable } from '@angular/core';

type Files = Array <File>;

@Injectable ( {
                providedIn: 'root'
              } )
export class HoldFileService
{
    private _files_: Files = [];

    constructor () {}

    public addFile ( file: File )
    {
        this._files_.push ( file );
    }

    public getFileWithName ( fileName: string ): File | null
    {
        const findFileWithName = ( file : File,
                                   index: number,
                                   files: Files ) =>
        {
            return ( file.name === fileName );
        };

        const matchedIndex: number = this._files_.findIndex ( findFileWithName );
        let   returnValue : File | null = null;

        if ( matchedIndex !== -1 )
            returnValue = this._files_ [ matchedIndex ];

        return ( returnValue );
    }

    public removeAllFiles ()
    {
        while ( this._files_.length > 0 )
            this._files_.pop ();
    }

    public removeFileWithName ( fileName: string )
    {
        const findFileWithName = ( file : File,
                                   index: number,
                                   files: Files ) =>
        {
            return ( file.name === fileName );
        }

        const matchedIndex = this._files_.findIndex ( findFileWithName );

        if ( matchedIndex !== -1 )
            this._files_.splice ( matchedIndex, 1 );
    }
}
